export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  googleSheetsCode?: Maybe<Scalars['String']['output']>;
  hubspotApiKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Deprecated in favor of `pages` field */
  pageConnection: PageConnection;
  pages: PageConnection;
  /** Counts pages. If requesting pages as well use edgeCount and totalCount fields instead */
  pagesCount: Scalars['Int']['output'];
  salesforceCode?: Maybe<Scalars['String']['output']>;
  salesforceDomain?: Maybe<Scalars['String']['output']>;
  templates: TemplateConnection;
};


export type AccountPageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityTypeFilter?: InputMaybe<EntityType>;
  entityTypesFilter?: InputMaybe<Array<EntityType>>;
  first?: InputMaybe<Scalars['Float']['input']>;
  ithacaFilter?: IthacaFilter;
  last?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: Order_Direction;
  where?: InputMaybe<PageSearch>;
};


export type AccountPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityTypeFilter?: InputMaybe<EntityType>;
  entityTypesFilter?: InputMaybe<Array<EntityType>>;
  first?: InputMaybe<Scalars['Float']['input']>;
  ithacaFilter?: IthacaFilter;
  last?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: Order_Direction;
  where?: InputMaybe<PageSearch>;
};


export type AccountPagesCountArgs = {
  ithacaFilter?: IthacaFilter;
};


export type AccountTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityTypeFilter?: InputMaybe<EntityType>;
  entityTypesFilter?: InputMaybe<Array<EntityType>>;
  first?: InputMaybe<Scalars['Float']['input']>;
  ithacaFilter?: IthacaFilter;
  last?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: Order_Direction;
  where?: InputMaybe<TemplateSearch>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  streetAddress1?: Maybe<Scalars['String']['output']>;
  streetAddress2?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  streetAddress1?: InputMaybe<Scalars['String']['input']>;
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
};

export type AssetEntityPermission = {
  __typename?: 'AssetEntityPermission';
  entityId: Scalars['String']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['Int']['output'];
  permissionName: Scalars['String']['output'];
};

export type AssetIdPermissionMap = {
  __typename?: 'AssetIdPermissionMap';
  assetId: Scalars['String']['output'];
  result: AssetPermissionsResult;
};

export type AssetPermissionsResult = {
  __typename?: 'AssetPermissionsResult';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssetTag = {
  __typename?: 'AssetTag';
  id: Scalars['ID']['output'];
  pageId: Scalars['ID']['output'];
  tagName: Scalars['String']['output'];
};

export type AssetTagFieldSearch = {
  tagName?: InputMaybe<PatternMatchSearch>;
};

export enum AssetTypes {
  Directory = 'Directory',
  Page = 'Page',
  Template = 'Template',
  WhiteLabel = 'WhiteLabel'
}

export type AutoDesignPage = {
  __typename?: 'AutoDesignPage';
  page: Page;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  templateId: Scalars['ID']['output'];
};

export type ContactCollectionRow = {
  __typename?: 'ContactCollectionRow';
  linkCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  linkDescription?: Maybe<Scalars['String']['output']>;
  linkId: Scalars['ID']['output'];
  linkLastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  linkTitle?: Maybe<Scalars['String']['output']>;
  pageId: Scalars['ID']['output'];
  pageSlug: Scalars['String']['output'];
  pageTitle?: Maybe<Scalars['String']['output']>;
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  address?: Maybe<Address>;
  age?: Maybe<Scalars['String']['output']>;
  capturedAt: Scalars['String']['output'];
  custom?: Maybe<CustomCapture>;
  custom2?: Maybe<CustomCapture>;
  displayData?: Maybe<LinkDisplayData>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ContactInfoCapture = {
  address?: InputMaybe<AddressInput>;
  age?: InputMaybe<Scalars['String']['input']>;
  custom?: InputMaybe<CustomCaptureInput>;
  custom2?: InputMaybe<CustomCaptureInput>;
  displayData?: InputMaybe<LinkDisplayDataInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  linkId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePageInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  createdFromTemplateId?: InputMaybe<Scalars['ID']['input']>;
  directoryId?: InputMaybe<Scalars['Int']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  domainServiceSubdomainId?: InputMaybe<Scalars['String']['input']>;
  isIndexed?: InputMaybe<Scalars['Boolean']['input']>;
  links?: InputMaybe<Array<LinkInput>>;
  pageType?: InputMaybe<PageType>;
  path?: InputMaybe<Scalars['String']['input']>;
  share?: InputMaybe<Scalars['Boolean']['input']>;
  slugName: Scalars['String']['input'];
  theme?: InputMaybe<ThemeInput>;
};

export type CreateTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isInheritable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};

export type CustomCapture = {
  __typename?: 'CustomCapture';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomCaptureInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Domain = {
  __typename?: 'Domain';
  deleteReason?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  domainServiceSubdomainId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type DomainManagementType = {
  __typename?: 'DomainManagementType';
  deletedAt?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  flowpageSubdomains: Array<DomainType>;
  id: Scalars['ID']['output'];
  type: Scalars['Int']['output'];
};

export type DomainType = {
  __typename?: 'DomainType';
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  isCoBranded: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  productType?: Maybe<Scalars['Int']['output']>;
};

export type EditPageInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  domainServiceSubdomainId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  pageType?: InputMaybe<PageType>;
  share?: InputMaybe<Scalars['Boolean']['input']>;
  templateConfig?: InputMaybe<TemplateConfigInput>;
};

export type EditTemplateInput = {
  data?: InputMaybe<TemplateDataInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EntityPermission = {
  __typename?: 'EntityPermission';
  entityId: Scalars['String']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['Int']['output'];
  permissionName: Scalars['String']['output'];
};

export type EntityPermissionInput = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['Int']['input'];
  permissionName: Scalars['String']['input'];
};

export enum EntityType {
  Org = 'ORG',
  Role = 'ROLE',
  Team = 'TEAM',
  User = 'USER'
}

export type FetchAssetDetails = {
  __typename?: 'FetchAssetDetails';
  assetId: Scalars['String']['output'];
  entityPermissions?: Maybe<Array<AssetEntityPermission>>;
  result: AssetPermissionsResult;
};

export type FlowcodeDesign = {
  __typename?: 'FlowcodeDesign';
  default: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  studioConfigId: Scalars['ID']['output'];
};

export type FlowcodeDesignInput = {
  default: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  studioConfigId: Scalars['ID']['input'];
};

export type GateInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  crmInput?: InputMaybe<Scalars['Boolean']['input']>;
  flowcodeId?: InputMaybe<Scalars['String']['input']>;
  nbaId?: InputMaybe<Scalars['String']['input']>;
  passwordAttempt?: InputMaybe<Scalars['String']['input']>;
};

/** Filtering for an entity */
export enum IthacaFilter {
  /** Return my entities and entities shared with me */
  All = 'ALL',
  /** Return only my owned entities */
  Owned = 'OWNED',
  /** Return only entities shared with me */
  Shared = 'SHARED'
}

export type KvInput = {
  operation?: InputMaybe<KvOperation>;
  path: Array<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

/** Defines the database operation to perform with the input */
export enum KvOperation {
  Concatenate = 'CONCATENATE'
}

/** expression to use for pattern matching */
export enum Like_Expression {
  /** postgres extension. Similar to LIKE except makes the match case-insensitive according to the active locale */
  Ilike = 'ILIKE',
  /** https://www.postgresql.org/docs/current/functions-matching.html#FUNCTIONS-LIKE */
  Like = 'LIKE'
}

export type Link = TemplateInterface & {
  __typename?: 'Link';
  actionData: Scalars['JSONObject']['output'];
  active: Scalars['Boolean']['output'];
  childLinks?: Maybe<Array<Link>>;
  description?: Maybe<Scalars['String']['output']>;
  displayType: Scalars['String']['output'];
  embed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  linkTheme?: Maybe<LinkTheme>;
  order: Scalars['Int']['output'];
  parentLinkId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  staticAssets?: Maybe<Array<StaticAsset>>;
  templateConfig?: Maybe<TemplateConfig>;
  theme?: Maybe<LinkTheme>;
  thumbNailImgUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LinkAnalytics = {
  __typename?: 'LinkAnalytics';
  clicksTotal: Scalars['Int']['output'];
  linkId: Scalars['ID']['output'];
  monthlyClicks: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  thumbNailImgUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  weeklyClicks: Scalars['Int']['output'];
};

export type LinkDisplayData = {
  __typename?: 'LinkDisplayData';
  description?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LinkDisplayDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LinkInput = {
  actionData?: InputMaybe<Scalars['JSONObject']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  childLinks?: InputMaybe<Array<LinkInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayType?: InputMaybe<Scalars['String']['input']>;
  embed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkTheme?: InputMaybe<LinkThemeInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  /** TemplateInput argument to indicate which page the action should be taken against - e.x. The page associated to the template or in the case of inheritance, one of the child pages */
  pageId?: InputMaybe<Scalars['ID']['input']>;
  parentLinkId?: InputMaybe<Scalars['ID']['input']>;
  provider: Scalars['String']['input'];
  templateConfig?: InputMaybe<TemplateConfigInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type LinkTheme = {
  __typename?: 'LinkTheme';
  active: Scalars['Boolean']['output'];
  borderColor?: Maybe<Scalars['String']['output']>;
  fontColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkColor?: Maybe<Scalars['String']['output']>;
  linkId: Scalars['String']['output'];
  shadowColor?: Maybe<Scalars['String']['output']>;
  textSize?: Maybe<Scalars['Int']['output']>;
};

export type LinkThemeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  fontColor?: InputMaybe<Scalars['String']['input']>;
  linkColor?: InputMaybe<Scalars['String']['input']>;
  shadowColor?: InputMaybe<Scalars['String']['input']>;
  textSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Defines an asset type whose position can be updated. */
export enum MoveAssetType {
  Template = 'TEMPLATE'
}

export type MoveLinkInput = {
  id: Scalars['ID']['input'];
  pageId?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addMailchimp: Scalars['String']['output'];
  assignTemplatePlans: Scalars['Boolean']['output'];
  authorizeSalesforceIntegration: Scalars['String']['output'];
  blockAndDeletePage: Scalars['Boolean']['output'];
  bulkDuplicatePages: Array<Page>;
  captureContactInfo: Scalars['Boolean']['output'];
  /** @deprecated deprecated in favor of code and page decoupling */
  changePageFlowcode: ShortUrl;
  createAssetTag: AssetTag;
  createAssetTags: Array<AssetTag>;
  /** @deprecated deprecated in favor of `createLink` mutation */
  createKlaviyoIntegration: Scalars['Boolean']['output'];
  createLink: Link;
  createOrEditLinkTheme: Array<LinkTheme>;
  createOrUpdateHubSpotIntegration: Scalars['Boolean']['output'];
  createPage: Page;
  createPageFromTemplate: Page;
  createPageSubdomain: Domain;
  createSlot: Slot;
  createTemplate: Template;
  deleteAccount: Scalars['Boolean']['output'];
  deleteAssetPermission: Array<PageIdPermissionMap>;
  deleteAssetTag: Scalars['Boolean']['output'];
  deleteAssetTags: Scalars['Boolean']['output'];
  deleteHubSpotIntegration: Scalars['Boolean']['output'];
  /** @deprecated deprecated in favor of `deleteLink` mutation */
  deleteKlaviyoIntegration: Scalars['Boolean']['output'];
  deleteLink: Scalars['Boolean']['output'];
  deleteMailchimp: Scalars['Boolean']['output'];
  deletePage: Scalars['Boolean']['output'];
  deletePageSubdomain: Scalars['Boolean']['output'];
  deleteSalesforceIntegration: Scalars['Boolean']['output'];
  deleteSlot: Scalars['Boolean']['output'];
  deleteTemplate: Scalars['Boolean']['output'];
  deleteTheme: Scalars['Boolean']['output'];
  /** @deprecated deprecated in favor of `editLink` mutation */
  editKlaviyoIntegration: Scalars['Boolean']['output'];
  editLink: Link;
  editMailchimp: Scalars['String']['output'];
  editPage: Page;
  editTemplate: Template;
  editTheme: Theme;
  enablePoapIntegration: Scalars['Boolean']['output'];
  hardDeleteTestPage: Scalars['Boolean']['output'];
  moveAsset: Scalars['String']['output'];
  moveLink: Link;
  /** Checks the current verification status of a custom subdomain and returns that status */
  refreshPageSubdomainStatus: Scalars['Boolean']['output'];
  renameSlug: Page;
  resetLinkThemes: Scalars['Boolean']['output'];
  /** Override any modifications made to pages created from the template */
  resetTemplate: Scalars['Boolean']['output'];
  restorePage: Scalars['Boolean']['output'];
  restorePageSubdomain: Scalars['Boolean']['output'];
  restoreTemplate: Template;
  shareAssetPermission: Array<PageIdPermissionMap>;
  shareAssets: Array<AssetIdPermissionMap>;
  storeKV: SlotKv;
  submitVote: Link;
  togglePageIndexed: Scalars['Boolean']['output'];
  /** @deprecated deprecated in favor of restore page. permissions is an old concept */
  togglePermission: Page;
  toggleVerified: Page;
  transferPage: Page;
  unshareAssets: Array<AssetIdPermissionMap>;
  updateSlot: Slot;
  verifyGoogleSheetsIntegration: Scalars['Boolean']['output'];
  verifySalesforceIntegration: Scalars['Boolean']['output'];
};


export type MutationAddMailchimpArgs = {
  apiKey: Scalars['String']['input'];
  pageId: Scalars['ID']['input'];
};


export type MutationAssignTemplatePlansArgs = {
  displayToAll?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  planIds: Array<Scalars['String']['input']>;
};


export type MutationAuthorizeSalesforceIntegrationArgs = {
  domain: Scalars['String']['input'];
};


export type MutationBlockAndDeletePageArgs = {
  domainServiceSubdomainId?: InputMaybe<Scalars['String']['input']>;
  slugName: Scalars['String']['input'];
};


export type MutationBulkDuplicatePagesArgs = {
  amount: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCaptureContactInfoArgs = {
  info: ContactInfoCapture;
};


export type MutationChangePageFlowcodeArgs = {
  batchId: Scalars['String']['input'];
  domainServiceSubdomainId?: InputMaybe<Scalars['String']['input']>;
  slugName: Scalars['String']['input'];
};


export type MutationCreateAssetTagArgs = {
  pageId: Scalars['ID']['input'];
  tagName: Scalars['String']['input'];
};


export type MutationCreateAssetTagsArgs = {
  pageId: Scalars['ID']['input'];
  tagNames: Array<Scalars['String']['input']>;
};


export type MutationCreateKlaviyoIntegrationArgs = {
  apiKey: Scalars['String']['input'];
  customListId?: InputMaybe<Scalars['String']['input']>;
  linkId: Scalars['ID']['input'];
};


export type MutationCreateLinkArgs = {
  linkInput: LinkInput;
  pageId: Scalars['ID']['input'];
};


export type MutationCreateOrEditLinkThemeArgs = {
  linkIds: Array<Scalars['ID']['input']>;
  linkThemeInput: LinkThemeInput;
};


export type MutationCreateOrUpdateHubSpotIntegrationArgs = {
  apiKey: Scalars['String']['input'];
};


export type MutationCreatePageArgs = {
  page: CreatePageInput;
};


export type MutationCreatePageFromTemplateArgs = {
  directoryId?: InputMaybe<Scalars['Float']['input']>;
  domainServiceSubdomainId?: InputMaybe<Scalars['String']['input']>;
  pageType?: InputMaybe<PageType>;
  path?: InputMaybe<Scalars['String']['input']>;
  slugName: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationCreatePageSubdomainArgs = {
  domainId: Scalars['String']['input'];
  subdomain: Scalars['String']['input'];
};


export type MutationCreateSlotArgs = {
  pageId: Scalars['ID']['input'];
  slotMetaType: Scalars['String']['input'];
  templateConfigInput?: InputMaybe<TemplateInput>;
  value: Scalars['JSONObject']['input'];
};


export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput;
  useDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteAccountArgs = {
  email: Scalars['String']['input'];
  removePages?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteAssetPermissionArgs = {
  entityId: Scalars['String']['input'];
  pageIds: Array<Scalars['ID']['input']>;
};


export type MutationDeleteAssetTagArgs = {
  tagId: Scalars['ID']['input'];
};


export type MutationDeleteAssetTagsArgs = {
  tagIds: Array<Scalars['ID']['input']>;
};


export type MutationDeleteKlaviyoIntegrationArgs = {
  linkId: Scalars['ID']['input'];
};


export type MutationDeleteLinkArgs = {
  linkId: Scalars['ID']['input'];
  pageId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteMailchimpArgs = {
  pageId: Scalars['ID']['input'];
};


export type MutationDeletePageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePageSubdomainArgs = {
  subdomainId: Scalars['String']['input'];
};


export type MutationDeleteSlotArgs = {
  pageId?: InputMaybe<Scalars['ID']['input']>;
  slotId: Scalars['ID']['input'];
};


export type MutationDeleteTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteThemeArgs = {
  themeId: Scalars['ID']['input'];
};


export type MutationEditKlaviyoIntegrationArgs = {
  linkId: Scalars['ID']['input'];
  newApiKey?: InputMaybe<Scalars['String']['input']>;
  newCustomListId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditLinkArgs = {
  linkId: Scalars['ID']['input'];
  linkInput: LinkInput;
};


export type MutationEditMailchimpArgs = {
  apiKey: Scalars['String']['input'];
  pageId: Scalars['ID']['input'];
};


export type MutationEditPageArgs = {
  editPage: EditPageInput;
};


export type MutationEditTemplateArgs = {
  id: Scalars['ID']['input'];
  input: EditTemplateInput;
};


export type MutationEditThemeArgs = {
  themeId: Scalars['ID']['input'];
  themeInput: ThemeInput;
};


export type MutationEnablePoapIntegrationArgs = {
  pageId: Scalars['ID']['input'];
};


export type MutationHardDeleteTestPageArgs = {
  pageId: Scalars['ID']['input'];
};


export type MutationMoveAssetArgs = {
  assetType: MoveAssetType;
  beforeId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationMoveLinkArgs = {
  input: MoveLinkInput;
};


export type MutationRefreshPageSubdomainStatusArgs = {
  domainServiceSubdomainId: Scalars['String']['input'];
};


export type MutationRenameSlugArgs = {
  domainServiceSubdomainId?: InputMaybe<Scalars['ID']['input']>;
  newSlug: Scalars['String']['input'];
  oldSlug: Scalars['String']['input'];
};


export type MutationResetLinkThemesArgs = {
  pageId: Scalars['ID']['input'];
};


export type MutationResetTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestorePageArgs = {
  domainServiceSubdomainId?: InputMaybe<Scalars['String']['input']>;
  slugName: Scalars['String']['input'];
};


export type MutationRestorePageSubdomainArgs = {
  domainServiceSubdomainId: Scalars['String']['input'];
};


export type MutationRestoreTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShareAssetPermissionArgs = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['Int']['input'];
  pageIds: Array<Scalars['ID']['input']>;
  sharedPermission: SharedAssetPermissions;
};


export type MutationShareAssetsArgs = {
  assetIds: Array<Scalars['String']['input']>;
  assetType: AssetTypes;
  entityPermissions: Array<EntityPermissionInput>;
};


export type MutationStoreKvArgs = {
  slotId: Scalars['ID']['input'];
  value: Scalars['JSONObject']['input'];
};


export type MutationSubmitVoteArgs = {
  vote: SubmitVote;
};


export type MutationTogglePageIndexedArgs = {
  pageId: Scalars['ID']['input'];
};


export type MutationTogglePermissionArgs = {
  domainServiceSubdomainId?: InputMaybe<Scalars['String']['input']>;
  slugName: Scalars['String']['input'];
};


export type MutationToggleVerifiedArgs = {
  domainServiceSubdomainId?: InputMaybe<Scalars['String']['input']>;
  slugName: Scalars['String']['input'];
};


export type MutationTransferPageArgs = {
  newOwnerEmail: Scalars['String']['input'];
  pageId: Scalars['ID']['input'];
};


export type MutationUnshareAssetsArgs = {
  assetIds: Array<Scalars['String']['input']>;
  assetType: AssetTypes;
  entityIds: Array<Scalars['String']['input']>;
};


export type MutationUpdateSlotArgs = {
  input?: InputMaybe<KvInput>;
  pageId?: InputMaybe<Scalars['ID']['input']>;
  slotId: Scalars['ID']['input'];
  templateConfigInput?: InputMaybe<TemplateInput>;
};


export type MutationVerifyGoogleSheetsIntegrationArgs = {
  code: Scalars['String']['input'];
};


export type MutationVerifySalesforceIntegrationArgs = {
  code: Scalars['String']['input'];
};

export type OgImage = {
  __typename?: 'OgImage';
  height?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type OgInfo = {
  __typename?: 'OgInfo';
  ogDescription?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<OgImage>;
  ogTitle?: Maybe<Scalars['String']['output']>;
  ogType?: Maybe<Scalars['String']['output']>;
  ogUrl?: Maybe<Scalars['String']['output']>;
  requestUrl?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** dictates what direction the field should be ordered in */
export enum Order_Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Owner = {
  __typename?: 'Owner';
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  ithacaId: Scalars['ID']['output'];
};

export type Page = TemplateInterface & {
  __typename?: 'Page';
  active: Scalars['Boolean']['output'];
  analytics?: Maybe<PageAnalytics>;
  assetTags?: Maybe<Array<AssetTag>>;
  baseTemplateId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of description */
  caption?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdFromTemplate?: Maybe<Template>;
  createdFromTemplateId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deleteReason?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directoryId?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Deprecated in favor of title */
  displayName?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Domain>;
  domainId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used */
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated deprecated in favor of code and page decoupling */
  flowcodeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isIndexed: Scalars['Boolean']['output'];
  links?: Maybe<Array<Link>>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Accessible only if user is part of an organization */
  owner?: Maybe<Owner>;
  pageType: PageType;
  permission?: Maybe<EntityPermission>;
  profileImage?: Maybe<Scalars['String']['output']>;
  share: Scalars['Boolean']['output'];
  /** @deprecated deprecated in favor of code and page decoupling effort */
  shortUrl: Scalars['String']['output'];
  slots?: Maybe<Array<Slot>>;
  slugName: Scalars['String']['output'];
  staticAssets?: Maybe<Array<StaticAsset>>;
  /** @deprecated deprecated in favor of analytics service */
  summaryStats: SummaryPageStats;
  templateConfig?: Maybe<TemplateConfig>;
  theme?: Maybe<Theme>;
  title?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};


export type PageSlotsArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PageAnalytics = {
  __typename?: 'PageAnalytics';
  /** @deprecated deprecated in favor of analytics service */
  linkStats: Array<LinkAnalytics>;
  /** @deprecated deprecated in favor of analytics service */
  monthlyClicks: Scalars['Int']['output'];
  /** @deprecated deprecated in favor of analytics service */
  monthlyScans: Scalars['Int']['output'];
  /** @deprecated deprecated in favor of analytics service */
  monthlyVisitors: Scalars['Int']['output'];
  pageId: Scalars['ID']['output'];
  totalClicks: Scalars['Int']['output'];
  /** @deprecated deprecated in favor of analytics service */
  totalScans: Scalars['Int']['output'];
  /** @deprecated deprecated in favor of analytics service */
  unattributedLinkStats: Array<LinkAnalytics>;
  /** @deprecated deprecated in favor of analytics service */
  uniqueMonthlyVisitors: Scalars['Int']['output'];
  /** @deprecated deprecated in favor of analytics service */
  uniqueVisitors: Scalars['Int']['output'];
  /** @deprecated deprecated in favor of analytics service */
  uniqueWeeklyVisitors: Scalars['Int']['output'];
  /** @deprecated deprecated in favor of analytics service */
  visitorsTotal: Scalars['Int']['output'];
  /** @deprecated deprecated in favor of analytics service */
  weeklyClicks: Scalars['Int']['output'];
  /** @deprecated deprecated in favor of analytics service */
  weeklyScans: Scalars['Int']['output'];
  /** @deprecated deprecated in favor of analytics service */
  weeklyVisitors: Scalars['Int']['output'];
};

export type PageConnection = {
  __typename?: 'PageConnection';
  edges: Array<Page>;
  edgesCount: Scalars['Int']['output'];
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PageFieldSearch = {
  assetTags?: InputMaybe<AssetTagFieldSearch>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  slugName?: InputMaybe<PatternMatchSearch>;
  title?: InputMaybe<PatternMatchSearch>;
};

export type PageIdPermissionMap = {
  __typename?: 'PageIdPermissionMap';
  pageId: Scalars['String']['output'];
  result: PermissionsResult;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageSearch = {
  AND?: InputMaybe<Array<PageFieldSearch>>;
  assetTags?: InputMaybe<AssetTagFieldSearch>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  OR?: InputMaybe<Array<PageFieldSearch>>;
  slugName?: InputMaybe<PatternMatchSearch>;
  title?: InputMaybe<PatternMatchSearch>;
};

/** Defines the pageType field */
export enum PageType {
  AlaskaWhale = 'ALASKA_WHALE',
  AmalfiVeinCutArgento = 'AMALFI_VEIN_CUT_ARGENTO',
  Bww = 'BWW',
  CentreBellEn = 'CENTRE_BELL_EN',
  CentreBellFr = 'CENTRE_BELL_FR',
  CentreBellLogeEn = 'CENTRE_BELL_LOGE_EN',
  CentreBellLogeFr = 'CENTRE_BELL_LOGE_FR',
  /** Used when creating a page through flowtag */
  Contact = 'CONTACT',
  Default = 'DEFAULT',
  FridayBeers = 'FRIDAY_BEERS',
  JimmyJohns = 'JIMMY_JOHNS',
  KingsTheatre = 'KINGS_THEATRE',
  LibertyMutual = 'LIBERTY_MUTUAL',
  Lrc = 'LRC',
  LumioRecruiting = 'LUMIO_RECRUITING',
  LumioRep = 'LUMIO_REP',
  LyricTheatreHarryPotter = 'LYRIC_THEATRE_HARRY_POTTER',
  Marriot = 'MARRIOT',
  MiamiHeat = 'MIAMI_HEAT',
  Michigan = 'MICHIGAN',
  Mischehler = 'MISCHEHLER',
  Orpheum = 'ORPHEUM',
  Panera = 'PANERA',
  Progressive = 'PROGRESSIVE',
  Sfc = 'SFC',
  SpecialOlympics = 'SPECIAL_OLYMPICS',
  Starbucks = 'STARBUCKS',
  StateFarm = 'STATE_FARM'
}

/** Determines which type of wildcard should be used */
export enum Pattern {
  /** Used for a contains match. like "slugName" = '%flowcode%'. Will match everything that contains "flowcode" */
  Contains = 'CONTAINS',
  /** Functionally equivalent to where "slugName" = 'flowcode'. */
  Equals = 'EQUALS',
  /** Used for a suffix match. like "slugName" = 'flowcode%'. Will match everything that starts with "flowcode" */
  Prefix = 'PREFIX',
  /** Used for a prefix match. like "slugName" = '%flowcode'. Will match everything that ends with "flowcode" */
  Suffix = 'SUFFIX'
}

export type PatternMatchSearch = {
  expression?: InputMaybe<Like_Expression>;
  /** Used to create exclusion filters */
  not?: InputMaybe<Scalars['Boolean']['input']>;
  pattern?: InputMaybe<Pattern>;
  value: Scalars['String']['input'];
};

export type PermissionsResult = {
  __typename?: 'PermissionsResult';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Query = {
  __typename?: 'Query';
  AdminPages: PageConnection;
  authorizeGoogleSheets: Scalars['String']['output'];
  autoDesignPages: Array<AutoDesignPage>;
  CapturedContactInfo: Array<ContactInfo>;
  checkPageOwnership: Scalars['Boolean']['output'];
  getAllSharedPagePermissions: Array<EntityPermission>;
  getAssetDetails: Array<FetchAssetDetails>;
  getBackgroundImageUrl?: Maybe<Scalars['String']['output']>;
  getBaseTemplate: Template;
  getContactCollectionManagementRows: Array<ContactCollectionRow>;
  getDomainManagementDetails: Array<DomainManagementType>;
  getLink: Link;
  getLinkImageUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated deprecated in favor of analytics service */
  getPageAnalytics: PageAnalytics;
  getPageAssetTags: Array<AssetTag>;
  getPagesForSubdomains: Array<Page>;
  getProfileImageUrl?: Maybe<Scalars['String']['output']>;
  getRecommendedAssetTags: Array<Scalars['String']['output']>;
  getSlugName: Scalars['String']['output'];
  getStaticAssets?: Maybe<Array<StaticAsset>>;
  getSubdomains: Array<DomainType>;
  getUserAssetTags: Array<AssetTag>;
  getUserPagesByAssetTag: Array<Page>;
  /** @deprecated deprecated in favor of `me` query with `googleSheetsCode` field */
  hasGooglesheets: Scalars['Boolean']['output'];
  /** @deprecated deprecated in favor of `me` query with `hubspotApiKey` field */
  hasHubSpotIntegration?: Maybe<Scalars['String']['output']>;
  hasKlaviyo?: Maybe<Scalars['String']['output']>;
  hasMailchimp?: Maybe<Scalars['String']['output']>;
  hasValidGooglesheetId: Scalars['Boolean']['output'];
  me: Account;
  ogInfo: OgInfo;
  Page: Page;
  slots: Array<Slot>;
  slugReserved: Scalars['Boolean']['output'];
  slugSuggestions: Array<Scalars['String']['output']>;
  template: Template;
  templates: TemplateConnection;
  unauthPage: UnauthPage;
};


export type QueryAdminPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: Order_Direction;
  userId: Scalars['String']['input'];
  where?: InputMaybe<PageSearch>;
};


export type QueryAutoDesignPagesArgs = {
  colors?: InputMaybe<Array<Scalars['String']['input']>>;
  count: Scalars['Int']['input'];
  logos?: InputMaybe<Array<Scalars['String']['input']>>;
  useCaseId: Scalars['String']['input'];
};


export type QueryCapturedContactInfoArgs = {
  linkId: Scalars['String']['input'];
};


export type QueryCheckPageOwnershipArgs = {
  pageId: Scalars['ID']['input'];
};


export type QueryGetAllSharedPagePermissionsArgs = {
  pageId: Scalars['ID']['input'];
};


export type QueryGetAssetDetailsArgs = {
  assetIds: Array<Scalars['String']['input']>;
  assetType: AssetTypes;
  entityTypes?: InputMaybe<Array<EntityType>>;
};


export type QueryGetBackgroundImageUrlArgs = {
  pageId: Scalars['ID']['input'];
};


export type QueryGetBaseTemplateArgs = {
  pageId: Scalars['ID']['input'];
};


export type QueryGetLinkArgs = {
  linkId: Scalars['ID']['input'];
};


export type QueryGetLinkImageUrlArgs = {
  linkId: Scalars['ID']['input'];
};


export type QueryGetPageAnalyticsArgs = {
  pageId: Scalars['ID']['input'];
};


export type QueryGetPageAssetTagsArgs = {
  pageId: Scalars['ID']['input'];
};


export type QueryGetPagesForSubdomainsArgs = {
  subdomainIds: Array<Scalars['ID']['input']>;
};


export type QueryGetProfileImageUrlArgs = {
  pageId: Scalars['ID']['input'];
};


export type QueryGetSlugNameArgs = {
  pageId: Scalars['ID']['input'];
};


export type QueryGetStaticAssetsArgs = {
  resourceId: Scalars['ID']['input'];
};


export type QueryGetUserPagesByAssetTagArgs = {
  tagName: Scalars['String']['input'];
};


export type QueryHasKlaviyoArgs = {
  linkId: Scalars['ID']['input'];
};


export type QueryHasMailchimpArgs = {
  pageId: Scalars['ID']['input'];
};


export type QueryHasValidGooglesheetIdArgs = {
  spreadsheetId: Scalars['String']['input'];
};


export type QueryOgInfoArgs = {
  url: Scalars['String']['input'];
};


export type QueryPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySlotsArgs = {
  pageId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySlugReservedArgs = {
  domainServiceSubdomainId?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QuerySlugSuggestionsArgs = {
  domainServiceSubdomainId?: InputMaybe<Scalars['String']['input']>;
  seed: Scalars['String']['input'];
  vertical?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityTypeFilter?: InputMaybe<EntityType>;
  entityTypesFilter?: InputMaybe<Array<EntityType>>;
  first?: InputMaybe<Scalars['Float']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  ithacaFilter?: IthacaFilter;
  last?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: Order_Direction;
  removeDisplayToAll?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TemplateSearch>;
};


export type QueryUnauthPageArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  domainServiceSubdomain?: InputMaybe<Scalars['String']['input']>;
  gateInput?: InputMaybe<GateInput>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
};

export enum SharedAssetPermissions {
  SharedPermissionsAdmin = 'SharedPermissionsAdmin',
  SharedPermissionsCreator = 'SharedPermissionsCreator',
  SharedPermissionsEditor = 'SharedPermissionsEditor',
  SharedPermissionsViewer = 'SharedPermissionsViewer'
}

export type ShortUrl = {
  __typename?: 'ShortUrl';
  shortUrl?: Maybe<Scalars['String']['output']>;
};

export type Slot = TemplateInterface & {
  __typename?: 'Slot';
  data: Scalars['JSONObject']['output'];
  id: Scalars['ID']['output'];
  slotMeta: SlotMeta;
  templateConfig?: Maybe<TemplateConfig>;
};

export type SlotKv = {
  __typename?: 'SlotKV';
  data: Scalars['JSONObject']['output'];
  id: Scalars['ID']['output'];
};

export type SlotMeta = {
  __typename?: 'SlotMeta';
  data: Scalars['JSONObject']['output'];
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type StaticAsset = {
  __typename?: 'StaticAsset';
  id: Scalars['String']['output'];
  type: StaticAssetType;
  url: Scalars['String']['output'];
};

/** Describes how the asset is used on a flowpage */
export enum StaticAssetType {
  BackgroundImage = 'BACKGROUND_IMAGE',
  LinkPdf = 'LINK_PDF',
  LinkThumbnail = 'LINK_THUMBNAIL',
  ProfileImage = 'PROFILE_IMAGE'
}

export type SubmitVote = {
  linkId: Scalars['ID']['input'];
  vote: Scalars['String']['input'];
};

export type SummaryPageStats = {
  __typename?: 'SummaryPageStats';
  avgClicksPerVisit: Scalars['Int']['output'];
  clicksLast7Days: Scalars['Int']['output'];
  pageVisits?: Maybe<Scalars['Int']['output']>;
  totalClicks: Scalars['Int']['output'];
};

export type Template = {
  __typename?: 'Template';
  childPages: PageConnection;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<TemplateData>;
  description?: Maybe<Scalars['String']['output']>;
  /** Used to toggle the different versions of the template card */
  displaySimpleCard: Scalars['Boolean']['output'];
  displayToAll: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isAssigned: Scalars['Boolean']['output'];
  isEditor: Scalars['Boolean']['output'];
  isInheritable: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  isViewer: Scalars['Boolean']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<Owner>;
  page: Page;
  pageId: Scalars['String']['output'];
  permission?: Maybe<EntityPermission>;
  position?: Maybe<Scalars['String']['output']>;
  taxonomyId?: Maybe<Scalars['String']['output']>;
};


export type TemplateChildPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: Order_Direction;
  where?: InputMaybe<PageSearch>;
};

export type TemplateConfig = {
  __typename?: 'TemplateConfig';
  fields?: Maybe<Array<TemplateConfigField>>;
  lockAll?: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Int']['output'];
  requireAll?: Maybe<Scalars['Boolean']['output']>;
};

export type TemplateConfigField = {
  __typename?: 'TemplateConfigField';
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export type TemplateConfigFieldInput = {
  locked: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
};

export type TemplateConfigInput = {
  fields?: InputMaybe<Array<TemplateConfigFieldInput>>;
  lockAll?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  requireAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TemplateConnection = {
  __typename?: 'TemplateConnection';
  edges: Array<TemplateEdge>;
  edgesCount: Scalars['Int']['output'];
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TemplateData = {
  __typename?: 'TemplateData';
  flowcodeDesigns: Array<FlowcodeDesign>;
};

export type TemplateDataInput = {
  flowcodeDesigns: Array<FlowcodeDesignInput>;
};

export type TemplateEdge = {
  __typename?: 'TemplateEdge';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<TemplateData>;
  description?: Maybe<Scalars['String']['output']>;
  /** Used to toggle the different versions of the template card */
  displaySimpleCard: Scalars['Boolean']['output'];
  displayToAll: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isAssigned: Scalars['Boolean']['output'];
  isEditor: Scalars['Boolean']['output'];
  isInheritable: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  isViewer: Scalars['Boolean']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<Owner>;
  page: Page;
  pageId: Scalars['String']['output'];
  permission?: Maybe<EntityPermission>;
  position?: Maybe<Scalars['String']['output']>;
  taxonomyId?: Maybe<Scalars['String']['output']>;
};

export type TemplateInput = {
  /** TemplateInput argument to indicate which page the action should be taken against - e.x. The page associated to the template or in the case of inheritance, one of the child pages */
  pageId?: InputMaybe<Scalars['ID']['input']>;
  templateConfig?: InputMaybe<TemplateConfigInput>;
};

export type TemplateInterface = {
  templateConfig?: Maybe<TemplateConfig>;
};

export type TemplateSearch = {
  name?: InputMaybe<PatternMatchSearch>;
};

export type Theme = TemplateInterface & {
  __typename?: 'Theme';
  backgroundImgUrl?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fontColor?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  linkColor?: Maybe<Scalars['String']['output']>;
  linkShape?: Maybe<Scalars['String']['output']>;
  linkStyle?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  profileImageMaskType?: Maybe<Scalars['String']['output']>;
  shadowColor?: Maybe<Scalars['String']['output']>;
  staticAssets?: Maybe<Array<StaticAsset>>;
  style?: Maybe<Scalars['String']['output']>;
  templateConfig?: Maybe<TemplateConfig>;
  textSize?: Maybe<Scalars['Int']['output']>;
  titleColor?: Maybe<Scalars['String']['output']>;
};

export type ThemeInput = {
  backgroundType?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  fontColor?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  linkColor?: InputMaybe<Scalars['String']['input']>;
  linkShape?: InputMaybe<Scalars['String']['input']>;
  linkStyle?: InputMaybe<Scalars['String']['input']>;
  /** TemplateInput argument to indicate which page the action should be taken against - e.x. The page associated to the template or in the case of inheritance, one of the child pages */
  pageId?: InputMaybe<Scalars['ID']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  profileImageMaskType?: InputMaybe<Scalars['String']['input']>;
  shadowColor?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  templateConfig?: InputMaybe<TemplateConfigInput>;
  textSize?: InputMaybe<Scalars['Int']['input']>;
  titleColor?: InputMaybe<Scalars['String']['input']>;
};

export type UnauthPage = TemplateInterface & {
  __typename?: 'UnauthPage';
  active: Scalars['Boolean']['output'];
  analytics?: Maybe<PageAnalytics>;
  assetTags?: Maybe<Array<AssetTag>>;
  baseTemplateId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of description */
  caption?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdFromTemplate?: Maybe<Template>;
  createdFromTemplateId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deleteReason?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directoryId?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Deprecated in favor of title */
  displayName?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Domain>;
  domainId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used */
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated deprecated in favor of code and page decoupling */
  flowcodeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isIndexed: Scalars['Boolean']['output'];
  links?: Maybe<Array<Link>>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Accessible only if user is part of an organization */
  owner?: Maybe<Owner>;
  pageType: PageType;
  permission?: Maybe<EntityPermission>;
  profileImage?: Maybe<Scalars['String']['output']>;
  share: Scalars['Boolean']['output'];
  /** @deprecated deprecated in favor of code and page decoupling effort */
  shortUrl: Scalars['String']['output'];
  slots?: Maybe<Array<Slot>>;
  slugName: Scalars['String']['output'];
  staticAssets?: Maybe<Array<StaticAsset>>;
  /** @deprecated deprecated in favor of analytics service */
  summaryStats: SummaryPageStats;
  templateConfig?: Maybe<TemplateConfig>;
  theme?: Maybe<Theme>;
  title?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};


export type UnauthPageSlotsArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};

export type LinkInfoFragment = { __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null };

export type LeanPageInfoFragment = { __typename?: 'Page', id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, active: boolean, pageType: PageType, slugName: string, verified: boolean, share: boolean, isIndexed: boolean, createdAt: any, assetTags?: Array<{ __typename?: 'AssetTag', id: string, tagName: string, pageId: string }> | null, permission?: { __typename?: 'EntityPermission', permissionName: string, entityId: string, entityName?: string | null } | null, links?: Array<{ __typename?: 'Link', type?: string | null }> | null, owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null, domain?: { __typename?: 'Domain', domain: string } | null };

export type MinimalPageInfoFragment = { __typename?: 'Page', id: string, displayName?: string | null, profileImage?: string | null, caption?: string | null, slugName: string };

export type AllPageInfoFragment = { __typename?: 'Page', id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, baseTemplateId?: string | null, active: boolean, pageType: PageType, slugName: string, domainId?: string | null, share: boolean, isIndexed: boolean, verified: boolean, createdAt: any, createdFromTemplate?: { __typename?: 'Template', pageId: string } | null, domain?: { __typename?: 'Domain', domainServiceSubdomainId: string, domain: string } | null, permission?: { __typename?: 'EntityPermission', permissionName: string, entityId: string, entityName?: string | null } | null, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null }> | null, assetTags?: Array<{ __typename?: 'AssetTag', id: string, tagName: string, pageId: string }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null, linkStyle?: string | null, linkShape?: string | null, fontFamily?: string | null, linkColor?: string | null, fontColor?: string | null, borderColor?: string | null, shadowColor?: string | null, titleColor?: string | null, textSize?: number | null, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null } | null, owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null, slots?: Array<{ __typename?: 'Slot', data: any, id: string, slotMeta: { __typename?: 'SlotMeta', type: string, id: string }, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null }> | null, templateConfig?: { __typename?: 'TemplateConfig', lockAll?: boolean | null, requireAll?: boolean | null, order: number, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null };

export type AdminPageInfoFragment = { __typename?: 'Page', deletedAt?: any | null, modifiedAt?: any | null, deleteReason?: string | null, id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, baseTemplateId?: string | null, active: boolean, pageType: PageType, slugName: string, domainId?: string | null, share: boolean, isIndexed: boolean, verified: boolean, createdAt: any, createdFromTemplate?: { __typename?: 'Template', pageId: string } | null, domain?: { __typename?: 'Domain', domainServiceSubdomainId: string, domain: string } | null, permission?: { __typename?: 'EntityPermission', permissionName: string, entityId: string, entityName?: string | null } | null, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null }> | null, assetTags?: Array<{ __typename?: 'AssetTag', id: string, tagName: string, pageId: string }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null, linkStyle?: string | null, linkShape?: string | null, fontFamily?: string | null, linkColor?: string | null, fontColor?: string | null, borderColor?: string | null, shadowColor?: string | null, titleColor?: string | null, textSize?: number | null, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null } | null, owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null, slots?: Array<{ __typename?: 'Slot', data: any, id: string, slotMeta: { __typename?: 'SlotMeta', type: string, id: string }, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null }> | null, templateConfig?: { __typename?: 'TemplateConfig', lockAll?: boolean | null, requireAll?: boolean | null, order: number, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null };

export type GetLinkQueryVariables = Exact<{
  linkId: Scalars['ID']['input'];
}>;


export type GetLinkQuery = { __typename?: 'Query', getLink: { __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null } };

export type ChangePageFlowcodeMutationVariables = Exact<{
  batchId: Scalars['String']['input'];
  slugName: Scalars['String']['input'];
}>;


export type ChangePageFlowcodeMutation = { __typename?: 'Mutation', changePageFlowcode: { __typename?: 'ShortUrl', shortUrl?: string | null } };

export type DeletePageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePageMutation = { __typename?: 'Mutation', deletePage: boolean };

export type TransferPageMutationVariables = Exact<{
  pageId: Scalars['ID']['input'];
  newOwnerEmail: Scalars['String']['input'];
}>;


export type TransferPageMutation = { __typename?: 'Mutation', transferPage: { __typename?: 'Page', id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, active: boolean, slugName: string, share: boolean, isIndexed: boolean, createdAt: any, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, displayType: string, order: number, embed: boolean, actionData: any }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null } | null } };

export type SubmitVoteMutationVariables = Exact<{
  vote: SubmitVote;
}>;


export type SubmitVoteMutation = { __typename?: 'Mutation', submitVote: { __typename?: 'Link', id: string, actionData: any, order: number, active: boolean, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, displayType: string, provider: string, embed: boolean } };

export type RestorePageMutationVariables = Exact<{
  slugName: Scalars['String']['input'];
  domainServiceSubdomainId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RestorePageMutation = { __typename?: 'Mutation', restorePage: boolean };

export type UpdateSlotMutationVariables = Exact<{
  slotId: Scalars['ID']['input'];
  input?: InputMaybe<KvInput>;
  templateConfigInput?: InputMaybe<TemplateInput>;
  pageId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateSlotMutation = { __typename?: 'Mutation', updateSlot: { __typename?: 'Slot', id: string, data: any } };

export type DeleteSlotMutationVariables = Exact<{
  slotId: Scalars['ID']['input'];
  pageId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteSlotMutation = { __typename?: 'Mutation', deleteSlot: boolean };

export type CaptureContactInfoMutationVariables = Exact<{
  info: ContactInfoCapture;
}>;


export type CaptureContactInfoMutation = { __typename?: 'Mutation', captureContactInfo: boolean };

export type CreateSlotMutationVariables = Exact<{
  pageId: Scalars['ID']['input'];
  slotMetaType: Scalars['String']['input'];
  value: Scalars['JSONObject']['input'];
  templateConfigInput?: InputMaybe<TemplateInput>;
}>;


export type CreateSlotMutation = { __typename?: 'Mutation', createSlot: { __typename?: 'Slot', id: string, data: any } };

export type BlockAndDeletePageMutationVariables = Exact<{
  slugName: Scalars['String']['input'];
}>;


export type BlockAndDeletePageMutation = { __typename?: 'Mutation', blockAndDeletePage: boolean };

export type DeleteAccountMutationVariables = Exact<{
  email: Scalars['String']['input'];
  removePages?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: boolean };

export type RenameSlugMutationVariables = Exact<{
  oldSlug: Scalars['String']['input'];
  newSlug: Scalars['String']['input'];
  domainServiceSubdomainId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RenameSlugMutation = { __typename?: 'Mutation', renameSlug: { __typename?: 'Page', id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, active: boolean, slugName: string, share: boolean, isIndexed: boolean, createdAt: any, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, displayType: string, order: number, embed: boolean, actionData: any }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null } | null } };

export type ToggleVerifiedMutationVariables = Exact<{
  slugName: Scalars['String']['input'];
}>;


export type ToggleVerifiedMutation = { __typename?: 'Mutation', toggleVerified: { __typename?: 'Page', id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, active: boolean, slugName: string, share: boolean, isIndexed: boolean, verified: boolean, createdAt: any, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, displayType: string, order: number, embed: boolean, actionData: any }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null } | null } };

export type BulkDuplicatePagesMutationVariables = Exact<{
  pageId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
}>;


export type BulkDuplicatePagesMutation = { __typename?: 'Mutation', bulkDuplicatePages: Array<{ __typename?: 'Page', id: string, slugName: string }> };

export type AddMailchimpMutationVariables = Exact<{
  apiKey: Scalars['String']['input'];
  pageId: Scalars['ID']['input'];
}>;


export type AddMailchimpMutation = { __typename?: 'Mutation', addMailchimp: string };

export type EditMailchimpMutationVariables = Exact<{
  apiKey: Scalars['String']['input'];
  pageId: Scalars['ID']['input'];
}>;


export type EditMailchimpMutation = { __typename?: 'Mutation', editMailchimp: string };

export type HasMailchimpQueryVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type HasMailchimpQuery = { __typename?: 'Query', hasMailchimp?: string | null };

export type DeleteMailchimpMutationVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type DeleteMailchimpMutation = { __typename?: 'Mutation', deleteMailchimp: boolean };

export type AuthorizeGoogleSheetsQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthorizeGoogleSheetsQuery = { __typename?: 'Query', authorizeGoogleSheets: string };

export type HasGooglesheetsQueryVariables = Exact<{ [key: string]: never; }>;


export type HasGooglesheetsQuery = { __typename?: 'Query', hasGooglesheets: boolean };

export type HasSpreadsheetQueryVariables = Exact<{
  spreadsheetId: Scalars['String']['input'];
}>;


export type HasSpreadsheetQuery = { __typename?: 'Query', hasValidGooglesheetId: boolean };

export type CreateOrUpdateHubSpotIntegrationMutationVariables = Exact<{
  apiKey: Scalars['String']['input'];
}>;


export type CreateOrUpdateHubSpotIntegrationMutation = { __typename?: 'Mutation', createOrUpdateHubSpotIntegration: boolean };

export type DeleteHubSpotIntegrationMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteHubSpotIntegrationMutation = { __typename?: 'Mutation', deleteHubSpotIntegration: boolean };

export type CreateLinkMutationVariables = Exact<{
  pageId: Scalars['ID']['input'];
  linkInput: LinkInput;
}>;


export type CreateLinkMutation = { __typename?: 'Mutation', createLink: { __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null } };

export type EditLinkMutationVariables = Exact<{
  linkId: Scalars['ID']['input'];
  linkInput: LinkInput;
}>;


export type EditLinkMutation = { __typename?: 'Mutation', editLink: { __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null } };

export type DeleteLinkMutationVariables = Exact<{
  linkId: Scalars['ID']['input'];
  pageId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteLinkMutation = { __typename?: 'Mutation', deleteLink: boolean };

export type CreateOrEditLinkThemeMutationVariables = Exact<{
  linkIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  linkThemeInput: LinkThemeInput;
}>;


export type CreateOrEditLinkThemeMutation = { __typename?: 'Mutation', createOrEditLinkTheme: Array<{ __typename?: 'LinkTheme', id: string, active: boolean, fontColor?: string | null, borderColor?: string | null, textSize?: number | null, linkColor?: string | null, shadowColor?: string | null }> };

export type EditThemeMutationVariables = Exact<{
  themeId: Scalars['ID']['input'];
  themeInput: ThemeInput;
}>;


export type EditThemeMutation = { __typename?: 'Mutation', editTheme: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null, linkColor?: string | null, borderColor?: string | null, shadowColor?: string | null, textSize?: number | null, fontColor?: string | null, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null } };

export type CreateAssetTagsMutationVariables = Exact<{
  tagNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  pageId: Scalars['ID']['input'];
}>;


export type CreateAssetTagsMutation = { __typename?: 'Mutation', createAssetTags: Array<{ __typename?: 'AssetTag', id: string }> };

export type DeleteAssetTagsMutationVariables = Exact<{
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteAssetTagsMutation = { __typename?: 'Mutation', deleteAssetTags: boolean };

export type EditPageMutationVariables = Exact<{
  editPage: EditPageInput;
}>;


export type EditPageMutation = { __typename?: 'Mutation', editPage: { __typename?: 'Page', id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, baseTemplateId?: string | null, active: boolean, pageType: PageType, slugName: string, domainId?: string | null, share: boolean, isIndexed: boolean, verified: boolean, createdAt: any, createdFromTemplate?: { __typename?: 'Template', pageId: string } | null, domain?: { __typename?: 'Domain', domainServiceSubdomainId: string, domain: string } | null, permission?: { __typename?: 'EntityPermission', permissionName: string, entityId: string, entityName?: string | null } | null, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null }> | null, assetTags?: Array<{ __typename?: 'AssetTag', id: string, tagName: string, pageId: string }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null, linkStyle?: string | null, linkShape?: string | null, fontFamily?: string | null, linkColor?: string | null, fontColor?: string | null, borderColor?: string | null, shadowColor?: string | null, titleColor?: string | null, textSize?: number | null, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null } | null, owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null, slots?: Array<{ __typename?: 'Slot', data: any, id: string, slotMeta: { __typename?: 'SlotMeta', type: string, id: string }, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null }> | null, templateConfig?: { __typename?: 'TemplateConfig', lockAll?: boolean | null, requireAll?: boolean | null, order: number, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null } };

export type CreatePageMutationVariables = Exact<{
  page: CreatePageInput;
}>;


export type CreatePageMutation = { __typename?: 'Mutation', createPage: { __typename?: 'Page', id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, baseTemplateId?: string | null, active: boolean, pageType: PageType, slugName: string, domainId?: string | null, share: boolean, isIndexed: boolean, verified: boolean, createdAt: any, createdFromTemplate?: { __typename?: 'Template', pageId: string } | null, domain?: { __typename?: 'Domain', domainServiceSubdomainId: string, domain: string } | null, permission?: { __typename?: 'EntityPermission', permissionName: string, entityId: string, entityName?: string | null } | null, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null }> | null, assetTags?: Array<{ __typename?: 'AssetTag', id: string, tagName: string, pageId: string }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null, linkStyle?: string | null, linkShape?: string | null, fontFamily?: string | null, linkColor?: string | null, fontColor?: string | null, borderColor?: string | null, shadowColor?: string | null, titleColor?: string | null, textSize?: number | null, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null } | null, owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null, slots?: Array<{ __typename?: 'Slot', data: any, id: string, slotMeta: { __typename?: 'SlotMeta', type: string, id: string }, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null }> | null, templateConfig?: { __typename?: 'TemplateConfig', lockAll?: boolean | null, requireAll?: boolean | null, order: number, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null } };

export type CreatePageFromTemplateMutationVariables = Exact<{
  slugName: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
  domainServiceSubdomainId?: InputMaybe<Scalars['String']['input']>;
  directoryId?: InputMaybe<Scalars['Float']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pageType?: InputMaybe<PageType>;
}>;


export type CreatePageFromTemplateMutation = { __typename?: 'Mutation', createPageFromTemplate: { __typename?: 'Page', id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, baseTemplateId?: string | null, active: boolean, pageType: PageType, slugName: string, domainId?: string | null, share: boolean, isIndexed: boolean, verified: boolean, createdAt: any, createdFromTemplate?: { __typename?: 'Template', pageId: string } | null, domain?: { __typename?: 'Domain', domainServiceSubdomainId: string, domain: string } | null, permission?: { __typename?: 'EntityPermission', permissionName: string, entityId: string, entityName?: string | null } | null, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null }> | null, assetTags?: Array<{ __typename?: 'AssetTag', id: string, tagName: string, pageId: string }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null, linkStyle?: string | null, linkShape?: string | null, fontFamily?: string | null, linkColor?: string | null, fontColor?: string | null, borderColor?: string | null, shadowColor?: string | null, titleColor?: string | null, textSize?: number | null, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null } | null, owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null, slots?: Array<{ __typename?: 'Slot', data: any, id: string, slotMeta: { __typename?: 'SlotMeta', type: string, id: string }, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null }> | null, templateConfig?: { __typename?: 'TemplateConfig', lockAll?: boolean | null, requireAll?: boolean | null, order: number, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null } };

export type ToggleIsIndexMutationVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type ToggleIsIndexMutation = { __typename?: 'Mutation', togglePageIndexed: boolean };

export type VerifyGoogleSheetsIntegrationMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type VerifyGoogleSheetsIntegrationMutation = { __typename?: 'Mutation', verifyGoogleSheetsIntegration: boolean };

export type CreatePageSubdomainMutationVariables = Exact<{
  subdomain: Scalars['String']['input'];
  domainId: Scalars['String']['input'];
}>;


export type CreatePageSubdomainMutation = { __typename?: 'Mutation', createPageSubdomain: { __typename?: 'Domain', id: string, domain: string, isActive: boolean, domainServiceSubdomainId: string } };

export type RestorePageSubdomainMutationVariables = Exact<{
  domainServiceSubdomainId: Scalars['String']['input'];
}>;


export type RestorePageSubdomainMutation = { __typename?: 'Mutation', restorePageSubdomain: boolean };

export type DeletePageSubdomainMutationVariables = Exact<{
  subdomainId: Scalars['String']['input'];
}>;


export type DeletePageSubdomainMutation = { __typename?: 'Mutation', deletePageSubdomain: boolean };

export type RefreshPageSubdomainStatusMutationVariables = Exact<{
  domainServiceSubdomainId: Scalars['String']['input'];
}>;


export type RefreshPageSubdomainStatusMutation = { __typename?: 'Mutation', refreshPageSubdomainStatus: boolean };

export type CreatePageTemplateMutationVariables = Exact<{
  useDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  input: CreateTemplateInput;
}>;


export type CreatePageTemplateMutation = { __typename?: 'Mutation', createTemplate: { __typename?: 'Template', id: string, name: string } };

export type AssignTemplatePlansMutationVariables = Exact<{
  planIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  id: Scalars['ID']['input'];
  displayToAll?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssignTemplatePlansMutation = { __typename?: 'Mutation', assignTemplatePlans: boolean };

export type ShareAssetsMutationVariables = Exact<{
  assetType: AssetTypes;
  entityPermissions: Array<EntityPermissionInput> | EntityPermissionInput;
  assetIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ShareAssetsMutation = { __typename?: 'Mutation', shareAssets: Array<{ __typename?: 'AssetIdPermissionMap', result: { __typename?: 'AssetPermissionsResult', success?: boolean | null, error?: string | null } }> };

export type UnshareAssetsMutationVariables = Exact<{
  assetType: AssetTypes;
  entityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  assetIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UnshareAssetsMutation = { __typename?: 'Mutation', unshareAssets: Array<{ __typename?: 'AssetIdPermissionMap', result: { __typename?: 'AssetPermissionsResult', success?: boolean | null, error?: string | null } }> };

export type EditPageTemplateMutationVariables = Exact<{
  input: EditTemplateInput;
  id: Scalars['ID']['input'];
}>;


export type EditPageTemplateMutation = { __typename?: 'Mutation', editTemplate: { __typename?: 'Template', id: string } };

export type DeletePageTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePageTemplateMutation = { __typename?: 'Mutation', deleteTemplate: boolean };

export type ResetLinkThemesMutationVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type ResetLinkThemesMutation = { __typename?: 'Mutation', resetLinkThemes: boolean };

export type DeleteThemeMutationVariables = Exact<{
  themeId: Scalars['ID']['input'];
}>;


export type DeleteThemeMutation = { __typename?: 'Mutation', deleteTheme: boolean };

export type EnablePoapIntegrationMutationVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type EnablePoapIntegrationMutation = { __typename?: 'Mutation', enablePoapIntegration: boolean };

export type MoveAssetMutationVariables = Exact<{
  beforeId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  assetType: MoveAssetType;
}>;


export type MoveAssetMutation = { __typename?: 'Mutation', moveAsset: string };

export type MoveLinkMutationVariables = Exact<{
  input: MoveLinkInput;
}>;


export type MoveLinkMutation = { __typename?: 'Mutation', moveLink: { __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null } };

export type GetBaseTemplateQueryVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type GetBaseTemplateQuery = { __typename?: 'Query', getBaseTemplate: { __typename?: 'Template', id: string, name: string, isInheritable: boolean, page: { __typename?: 'Page', profileImage?: string | null, theme?: { __typename?: 'Theme', id: string } | null } } };

export type UnauthPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  domainServiceSubdomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnauthPageQuery = { __typename?: 'Query', unauthPage: { __typename?: 'UnauthPage', id: string, displayName?: string | null, email?: string | null, profileImage?: string | null, caption?: string | null, active: boolean, pageType: PageType, slugName: string, verified: boolean, share: boolean, isIndexed: boolean, domain?: { __typename?: 'Domain', domain: string } | null, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null, linkStyle?: string | null, linkShape?: string | null, linkColor?: string | null, fontColor?: string | null, borderColor?: string | null, textSize?: number | null, shadowColor?: string | null, titleColor?: string | null, fontFamily?: string | null } | null, slots?: Array<{ __typename?: 'Slot', data: any, id: string, slotMeta: { __typename?: 'SlotMeta', type: string, id: string } }> | null } };

export type GetPageDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPageDetailsQuery = { __typename?: 'Query', Page: { __typename?: 'Page', id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, baseTemplateId?: string | null, active: boolean, pageType: PageType, slugName: string, domainId?: string | null, share: boolean, isIndexed: boolean, verified: boolean, createdAt: any, createdFromTemplate?: { __typename?: 'Template', pageId: string } | null, domain?: { __typename?: 'Domain', domainServiceSubdomainId: string, domain: string } | null, permission?: { __typename?: 'EntityPermission', permissionName: string, entityId: string, entityName?: string | null } | null, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null }> | null, assetTags?: Array<{ __typename?: 'AssetTag', id: string, tagName: string, pageId: string }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null, linkStyle?: string | null, linkShape?: string | null, fontFamily?: string | null, linkColor?: string | null, fontColor?: string | null, borderColor?: string | null, shadowColor?: string | null, titleColor?: string | null, textSize?: number | null, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null } | null, owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null, slots?: Array<{ __typename?: 'Slot', data: any, id: string, slotMeta: { __typename?: 'SlotMeta', type: string, id: string }, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null }> | null, templateConfig?: { __typename?: 'TemplateConfig', lockAll?: boolean | null, requireAll?: boolean | null, order: number, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null } };

export type GetPageLinksQueryVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type GetPageLinksQuery = { __typename?: 'Query', Page: { __typename?: 'Page', links?: Array<{ __typename?: 'Link', type?: string | null }> | null } };

export type GetAdminPageDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAdminPageDetailsQuery = { __typename?: 'Query', Page: { __typename?: 'Page', deletedAt?: any | null, modifiedAt?: any | null, deleteReason?: string | null, id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, baseTemplateId?: string | null, active: boolean, pageType: PageType, slugName: string, domainId?: string | null, share: boolean, isIndexed: boolean, verified: boolean, createdAt: any, createdFromTemplate?: { __typename?: 'Template', pageId: string } | null, domain?: { __typename?: 'Domain', domainServiceSubdomainId: string, domain: string } | null, permission?: { __typename?: 'EntityPermission', permissionName: string, entityId: string, entityName?: string | null } | null, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null }> | null, assetTags?: Array<{ __typename?: 'AssetTag', id: string, tagName: string, pageId: string }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null, linkStyle?: string | null, linkShape?: string | null, fontFamily?: string | null, linkColor?: string | null, fontColor?: string | null, borderColor?: string | null, shadowColor?: string | null, titleColor?: string | null, textSize?: number | null, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null } | null, owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null, slots?: Array<{ __typename?: 'Slot', data: any, id: string, slotMeta: { __typename?: 'SlotMeta', type: string, id: string }, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null }> | null, templateConfig?: { __typename?: 'TemplateConfig', lockAll?: boolean | null, requireAll?: boolean | null, order: number, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null } };

export type GetAdminPagesQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Float']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Order_Direction>;
  where?: InputMaybe<PageSearch>;
}>;


export type GetAdminPagesQuery = { __typename?: 'Query', AdminPages: { __typename?: 'PageConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'Page', deletedAt?: any | null, modifiedAt?: any | null, deleteReason?: string | null, id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, baseTemplateId?: string | null, active: boolean, pageType: PageType, slugName: string, domainId?: string | null, share: boolean, isIndexed: boolean, verified: boolean, createdAt: any, createdFromTemplate?: { __typename?: 'Template', pageId: string } | null, domain?: { __typename?: 'Domain', domainServiceSubdomainId: string, domain: string } | null, permission?: { __typename?: 'EntityPermission', permissionName: string, entityId: string, entityName?: string | null } | null, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null }> | null, assetTags?: Array<{ __typename?: 'AssetTag', id: string, tagName: string, pageId: string }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null, linkStyle?: string | null, linkShape?: string | null, fontFamily?: string | null, linkColor?: string | null, fontColor?: string | null, borderColor?: string | null, shadowColor?: string | null, titleColor?: string | null, textSize?: number | null, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null } | null, owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null, slots?: Array<{ __typename?: 'Slot', data: any, id: string, slotMeta: { __typename?: 'SlotMeta', type: string, id: string }, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null }> | null, templateConfig?: { __typename?: 'TemplateConfig', lockAll?: boolean | null, requireAll?: boolean | null, order: number, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null }> } };

export type UnauthPageImageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type UnauthPageImageQuery = { __typename?: 'Query', unauthPage: { __typename?: 'UnauthPage', profileImage?: string | null } };

export type SlugReservedQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  domainServiceSubdomainId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SlugReservedQuery = { __typename?: 'Query', slugReserved: boolean };

export type VerifiedStatusQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type VerifiedStatusQuery = { __typename?: 'Query', unauthPage: { __typename?: 'UnauthPage', verified: boolean } };

export type CapturedContactInfoQueryVariables = Exact<{
  linkId: Scalars['String']['input'];
}>;


export type CapturedContactInfoQuery = { __typename?: 'Query', CapturedContactInfo: Array<{ __typename?: 'ContactInfo', email?: string | null, phone?: string | null, displayName?: string | null, gender?: string | null, age?: string | null, capturedAt: string, custom?: { __typename?: 'CustomCapture', value?: string | null } | null, custom2?: { __typename?: 'CustomCapture', value?: string | null } | null, address?: { __typename?: 'Address', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null } | null, displayData?: { __typename?: 'LinkDisplayData', title?: string | null, description?: string | null, order?: number | null } | null }> };

export type GetPageAnalyticsQueryVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type GetPageAnalyticsQuery = { __typename?: 'Query', getPageAnalytics: { __typename?: 'PageAnalytics', visitorsTotal: number, monthlyVisitors: number, weeklyVisitors: number, uniqueVisitors: number, uniqueMonthlyVisitors: number, uniqueWeeklyVisitors: number, totalScans: number, monthlyScans: number, weeklyScans: number, totalClicks: number, monthlyClicks: number, weeklyClicks: number, unattributedLinkStats: Array<{ __typename?: 'LinkAnalytics', title?: string | null, provider: string, type?: string | null, order: number, thumbNailImgUrl?: string | null, clicksTotal: number, monthlyClicks: number, weeklyClicks: number }>, linkStats: Array<{ __typename?: 'LinkAnalytics', title?: string | null, provider: string, type?: string | null, order: number, thumbNailImgUrl?: string | null, clicksTotal: number, monthlyClicks: number, weeklyClicks: number }> } };

export type SlotQueryVariables = Exact<{
  pageId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type SlotQuery = { __typename?: 'Query', slots: Array<{ __typename?: 'Slot', id: string, data: any, slotMeta: { __typename?: 'SlotMeta', type: string } }> };

export type SlugSuggestionsQueryVariables = Exact<{
  seed: Scalars['String']['input'];
  vertical?: InputMaybe<Scalars['String']['input']>;
}>;


export type SlugSuggestionsQuery = { __typename?: 'Query', slugSuggestions: Array<string> };

export type GetOgInfoFromUrlQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type GetOgInfoFromUrlQuery = { __typename?: 'Query', ogInfo: { __typename?: 'OgInfo', ogTitle?: string | null, ogDescription?: string | null, ogImage?: { __typename?: 'OgImage', url?: string | null } | null } };

export type PagePermissionQueryVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type PagePermissionQuery = { __typename?: 'Query', checkPageOwnership: boolean };

export type AccountHasHubSpotQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountHasHubSpotQuery = { __typename?: 'Query', hasHubSpotIntegration?: string | null };

export type GetFlowpageAssetLabelsQueryVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type GetFlowpageAssetLabelsQuery = { __typename?: 'Query', getPageAssetTags: Array<{ __typename?: 'AssetTag', id: string, tagName: string }> };

export type GetUserAssetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAssetTagsQuery = { __typename?: 'Query', getUserAssetTags: Array<{ __typename?: 'AssetTag', id: string, tagName: string }> };

export type GetRecommendedAssetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecommendedAssetTagsQuery = { __typename?: 'Query', getRecommendedAssetTags: Array<string> };

export type HighlightedFlowpagesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Float']['input']>;
}>;


export type HighlightedFlowpagesQuery = { __typename?: 'Query', me: { __typename?: 'Account', pageConnection: { __typename?: 'PageConnection', edges: Array<{ __typename?: 'Page', displayName?: string | null, slugName: string, profileImage?: string | null, id: string, theme?: { __typename?: 'Theme', profileImageMaskType?: string | null } | null, domain?: { __typename?: 'Domain', domain: string } | null }> } } };

export type PageManagementMeQueryVariables = Exact<{
  ithacaFilter?: InputMaybe<IthacaFilter>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Order_Direction>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PageSearch>;
}>;


export type PageManagementMeQuery = { __typename?: 'Query', me: { __typename?: 'Account', pageConnection: { __typename?: 'PageConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'Page', id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, active: boolean, pageType: PageType, slugName: string, verified: boolean, share: boolean, isIndexed: boolean, createdAt: any, theme?: { __typename?: 'Theme', profileImageMaskType?: string | null } | null, assetTags?: Array<{ __typename?: 'AssetTag', id: string, tagName: string, pageId: string }> | null, permission?: { __typename?: 'EntityPermission', permissionName: string, entityId: string, entityName?: string | null } | null, links?: Array<{ __typename?: 'Link', type?: string | null }> | null, owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null, domain?: { __typename?: 'Domain', domain: string } | null }> } } };

export type AccountInfoMeQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountInfoMeQuery = { __typename?: 'Query', me: { __typename?: 'Account', id: string, email: string, googleSheetsCode?: string | null, hubspotApiKey?: string | null, createdAt: any } };

export type PageCountQueryVariables = Exact<{
  ithacaFilter?: IthacaFilter;
}>;


export type PageCountQuery = { __typename?: 'Query', me: { __typename?: 'Account', pageConnection: { __typename?: 'PageConnection', totalCount: number } } };

export type UnauthPageIdQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  domainServiceSubdomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnauthPageIdQuery = { __typename?: 'Query', unauthPage: { __typename?: 'UnauthPage', id: string, email?: string | null } };

export type GetSubdomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubdomainsQuery = { __typename?: 'Query', getSubdomains: Array<{ __typename?: 'DomainType', domain: string, id?: string | null, createdAt?: string | null, isCoBranded: boolean, isDefault: boolean }> };

export type GetAssetDetailsQueryVariables = Exact<{
  assetIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  assetType: AssetTypes;
}>;


export type GetAssetDetailsQuery = { __typename?: 'Query', getAssetDetails: Array<{ __typename?: 'FetchAssetDetails', assetId: string, result: { __typename?: 'AssetPermissionsResult', success?: boolean | null, error?: string | null }, entityPermissions?: Array<{ __typename?: 'AssetEntityPermission', entityId: string, entityType: number, permissionName: string, entityName?: string | null }> | null }> };

export type GetPagesForSubdomainsQueryVariables = Exact<{
  subdomainIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetPagesForSubdomainsQuery = { __typename?: 'Query', getPagesForSubdomains: Array<{ __typename?: 'Page', id: string, slugName: string }> };

export type GetPageTemplatePermissionsQueryVariables = Exact<{
  assetType: AssetTypes;
  assetIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
  entityTypes?: InputMaybe<Array<EntityType> | EntityType>;
}>;


export type GetPageTemplatePermissionsQuery = { __typename?: 'Query', getAssetDetails: Array<{ __typename?: 'FetchAssetDetails', entityPermissions?: Array<{ __typename?: 'AssetEntityPermission', entityId: string, entityName?: string | null, entityType: number, permissionName: string }> | null }>, template: { __typename?: 'Template', owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null } };

export type DomainManagementQueryVariables = Exact<{ [key: string]: never; }>;


export type DomainManagementQuery = { __typename?: 'Query', getDomainManagementDetails: Array<{ __typename?: 'DomainManagementType', id: string, domain: string, type: number, deletedAt?: string | null, flowpageSubdomains: Array<{ __typename?: 'DomainType', id?: string | null, domain: string, isCoBranded: boolean, productType?: number | null, createdAt?: string | null, deletedAt?: string | null, isVerified?: boolean | null }> }> };

export type GetTemplateAssetDetailsQueryVariables = Exact<{
  assetType: AssetTypes;
  assetIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  entityTypes?: InputMaybe<Array<EntityType> | EntityType>;
}>;


export type GetTemplateAssetDetailsQuery = { __typename?: 'Query', getAssetDetails: Array<{ __typename?: 'FetchAssetDetails', entityPermissions?: Array<{ __typename?: 'AssetEntityPermission', entityId: string, entityName?: string | null, entityType: number, permissionName: string }> | null }> };

export type GetPageTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPageTemplateQuery = { __typename?: 'Query', template: { __typename?: 'Template', id: string, name: string, isViewer: boolean, description?: string | null, isOwner: boolean, isEditor: boolean, modifiedAt?: any | null, position?: string | null, isInheritable: boolean, owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null, page: { __typename?: 'Page', id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, baseTemplateId?: string | null, active: boolean, pageType: PageType, slugName: string, domainId?: string | null, share: boolean, isIndexed: boolean, verified: boolean, createdAt: any, createdFromTemplate?: { __typename?: 'Template', pageId: string } | null, domain?: { __typename?: 'Domain', domainServiceSubdomainId: string, domain: string } | null, permission?: { __typename?: 'EntityPermission', permissionName: string, entityId: string, entityName?: string | null } | null, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null }> | null, assetTags?: Array<{ __typename?: 'AssetTag', id: string, tagName: string, pageId: string }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null, linkStyle?: string | null, linkShape?: string | null, fontFamily?: string | null, linkColor?: string | null, fontColor?: string | null, borderColor?: string | null, shadowColor?: string | null, titleColor?: string | null, textSize?: number | null, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null } | null, owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null, slots?: Array<{ __typename?: 'Slot', data: any, id: string, slotMeta: { __typename?: 'SlotMeta', type: string, id: string }, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null }> | null, templateConfig?: { __typename?: 'TemplateConfig', lockAll?: boolean | null, requireAll?: boolean | null, order: number, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null }, data?: { __typename?: 'TemplateData', flowcodeDesigns: Array<{ __typename?: 'FlowcodeDesign', studioConfigId: string, default: boolean, name?: string | null }> } | null } };

export type GetPageTemplatesCountQueryVariables = Exact<{
  ithacaFilter?: IthacaFilter;
  removeDisplayToAll?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPageTemplatesCountQuery = { __typename?: 'Query', templates: { __typename?: 'TemplateConnection', totalCount: number } };

export type GetTemplateChildPagesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: Order_Direction;
}>;


export type GetTemplateChildPagesQuery = { __typename?: 'Query', template: { __typename?: 'Template', name: string, childPages: { __typename?: 'PageConnection', totalCount: number, edges: Array<{ __typename?: 'Page', id: string, slugName: string }> } } };

export type GetFlowpageTemplatesQueryVariables = Exact<{
  where?: InputMaybe<TemplateSearch>;
  ithacaFilter?: IthacaFilter;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: Order_Direction;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Float']['input']>;
  entityTypeFilter?: InputMaybe<EntityType>;
  entityTypesFilter?: InputMaybe<Array<EntityType> | EntityType>;
  removeDisplayToAll?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetFlowpageTemplatesQuery = { __typename?: 'Query', templates: { __typename?: 'TemplateConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'TemplateEdge', id: string, name: string, description?: string | null, isInheritable: boolean, position?: string | null, createdAt: any, modifiedAt?: any | null, displaySimpleCard: boolean, isAssigned: boolean, isOwner: boolean, isEditor: boolean, isViewer: boolean, displayToAll: boolean, data?: { __typename?: 'TemplateData', flowcodeDesigns: Array<{ __typename?: 'FlowcodeDesign', studioConfigId: string, default: boolean, name?: string | null }> } | null, permission?: { __typename?: 'EntityPermission', entityId: string, entityName?: string | null, entityType: number, permissionName: string } | null, page: { __typename?: 'Page', id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, baseTemplateId?: string | null, active: boolean, pageType: PageType, slugName: string, domainId?: string | null, share: boolean, isIndexed: boolean, verified: boolean, createdAt: any, createdFromTemplate?: { __typename?: 'Template', pageId: string } | null, domain?: { __typename?: 'Domain', domainServiceSubdomainId: string, domain: string } | null, permission?: { __typename?: 'EntityPermission', permissionName: string, entityId: string, entityName?: string | null } | null, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null }> | null, assetTags?: Array<{ __typename?: 'AssetTag', id: string, tagName: string, pageId: string }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null, linkStyle?: string | null, linkShape?: string | null, fontFamily?: string | null, linkColor?: string | null, fontColor?: string | null, borderColor?: string | null, shadowColor?: string | null, titleColor?: string | null, textSize?: number | null, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null } | null, owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null, slots?: Array<{ __typename?: 'Slot', data: any, id: string, slotMeta: { __typename?: 'SlotMeta', type: string, id: string }, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null }> | null, templateConfig?: { __typename?: 'TemplateConfig', lockAll?: boolean | null, requireAll?: boolean | null, order: number, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null }, owner?: { __typename?: 'Owner', ithacaId: string } | null }> } };

export type GetFlowcodeIdFromFlowpageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetFlowcodeIdFromFlowpageQuery = { __typename?: 'Query', unauthPage: { __typename?: 'UnauthPage', flowcodeId?: string | null } };

export type GetContactCollectionManagementRowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactCollectionManagementRowsQuery = { __typename?: 'Query', getContactCollectionManagementRows: Array<{ __typename?: 'ContactCollectionRow', linkId: string, linkTitle?: string | null, linkDescription?: string | null, linkCreatedAt?: any | null, linkLastModifiedAt?: any | null, pageId: string, pageSlug: string, pageTitle?: string | null }> };

export type AutoDesignPagesQueryVariables = Exact<{
  useCaseId: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  colors?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  logos?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AutoDesignPagesQuery = { __typename?: 'Query', autoDesignPages: Array<{ __typename?: 'AutoDesignPage', templateId: string, profileImageUrl?: string | null, page: { __typename?: 'Page', id: string, displayName?: string | null, email?: string | null, shortUrl: string, profileImage?: string | null, caption?: string | null, baseTemplateId?: string | null, active: boolean, pageType: PageType, slugName: string, domainId?: string | null, share: boolean, isIndexed: boolean, verified: boolean, createdAt: any, createdFromTemplate?: { __typename?: 'Template', pageId: string } | null, domain?: { __typename?: 'Domain', domainServiceSubdomainId: string, domain: string } | null, permission?: { __typename?: 'EntityPermission', permissionName: string, entityId: string, entityName?: string | null } | null, links?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, thumbNailImgUrl?: string | null, order: number, position?: string | null, embed: boolean, displayType: string, actionData: any, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null, childLinks?: Array<{ __typename?: 'Link', id: string, active: boolean, provider: string, type?: string | null, title?: string | null, description?: string | null, order: number, actionData: any, parentLinkId?: string | null, thumbNailImgUrl?: string | null }> | null, linkTheme?: { __typename?: 'LinkTheme', linkColor?: string | null, fontColor?: string | null, textSize?: number | null, borderColor?: string | null, shadowColor?: string | null, active: boolean } | null }> | null, assetTags?: Array<{ __typename?: 'AssetTag', id: string, tagName: string, pageId: string }> | null, theme?: { __typename?: 'Theme', id: string, primaryColor?: string | null, style?: string | null, profileImageMaskType?: string | null, backgroundImgUrl?: string | null, linkStyle?: string | null, linkShape?: string | null, fontFamily?: string | null, linkColor?: string | null, fontColor?: string | null, borderColor?: string | null, shadowColor?: string | null, titleColor?: string | null, textSize?: number | null, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null } | null, owner?: { __typename?: 'Owner', displayName?: string | null, email: string, ithacaId: string } | null, slots?: Array<{ __typename?: 'Slot', data: any, id: string, slotMeta: { __typename?: 'SlotMeta', type: string, id: string }, templateConfig?: { __typename?: 'TemplateConfig', order: number, lockAll?: boolean | null, requireAll?: boolean | null, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, locked: boolean, required: boolean }> | null } | null }> | null, templateConfig?: { __typename?: 'TemplateConfig', lockAll?: boolean | null, requireAll?: boolean | null, order: number, fields?: Array<{ __typename?: 'TemplateConfigField', name: string, required: boolean, locked: boolean }> | null } | null } }> };
